import { apiReducer } from 'utils/API'
import {
  UNITIES_ALLOWED
} from '../constants'

export default apiReducer({
  entity: UNITIES_ALLOWED,
})